import styled from 'styled-components/macro';

import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

type ReportStateStyledT = {
  isReportOpened: boolean;
};

type CardWrapStyledT = {
  isActive: boolean;
};

const reportHeaderHeight = 48;
const cardsBlockHeight = 185;
const cardsClosedTranslateValue = -(reportHeaderHeight + cardsBlockHeight);

export const ScheduleTilesOuterWrapStyled = styled(FlexContainer)`
  flex-direction: column;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 6px;
  gap: 0;
`;

export const RowLabelStyled = styled(Typography)`
  margin-bottom: 6px;
  font-weight: ${({ theme }): string => theme.fontWeight.semibold.toString()};
  align-self: flex-start;
`;

export const CardsRowStyled = styled(FlexContainer)`
  flex-wrap: nowrap;
  gap: 6px;
  width: 100%;
  margin-bottom: 12px;
  overflow-x: auto;
  & > div {
    width: 100%;
  }
`;

type SuggestedAdjustmentsRowStyledT = {
  isOpened: boolean;
};

const suggestedRowHeight = 130;
export const SuggestedAdjustmentsRowStyled = styled(FlexContainer)<SuggestedAdjustmentsRowStyledT>`
  flex-direction: column;
  width: 100%;
  max-height: ${({ isOpened }): string => (isOpened ? `${suggestedRowHeight}px` : '0')};
  overflow: hidden;
  transition: max-height 0.25s linear;
`;

export const CardsWrapStyled = styled(FlexContainer)<ReportStateStyledT>`
  flex-wrap: nowrap;
  gap: 6px;
  width: 100%;
  margin-top: ${({ isReportOpened }): string => (isReportOpened ? '20px' : '0')};
  margin-bottom: 6px;
  max-height: ${({ isReportOpened }): string => (isReportOpened ? '110px' : '0')};
  overflow-x: auto;
  transform: ${({ isReportOpened }): string =>
    isReportOpened ? 'translateY(0)' : `translateY(${cardsClosedTranslateValue}px)`};
  z-index: 0;
  transition: max-height 0.25s linear, transform 0.3s linear;
  & > div {
    width: 100%;
  }
  & + div {
    margin-top: 0;
  }
`;

export const CardWrapStyled = styled(FlexContainer)<CardWrapStyledT>`
  height: 100%;
  min-width: 210px;
  max-height: 90px;
  padding: 10px;
  position: relative;
  border-radius: ${({ theme }): string => theme.radius.lg};
  background: ${({ isActive, theme }): string =>
    isActive ? theme.colors.secondary.variant3 : theme.colors.white};
  border: 1px solid ${({ theme }): string => theme.colors.primary.variant6};
`;

export const InnerContentStyled = styled(FlexContainer)`
  align-self: baseline;
  gap: 10px;
  width: 100%;
`;

export const ClaimReportInnerContentStyled = styled(InnerContentStyled)`
  gap: 8px;
`;

export const AmountStyled = styled(Typography)`
  max-width: 70%;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
`;

export const InnerContentRowStyled = styled(FlexContainer)`
  width: 100%;
`;
